import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Company } from 'src/app/core/companies.service';

@Component({
  selector: 'app-archived-companies-note-dialog',
  templateUrl: './archived-companies-note-dialog.component.html',
  styleUrls: ['./archived-companies-note-dialog.component.scss'],
})
export class ArchivedCompaniesNoteDialogComponent {
  company?: Company;

  constructor(
    private dialog_ref: MatDialogRef<ArchivedCompaniesNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.company = data.company;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }
}
